// TO DEFINE THE STATES AND CHANGE STATUS
import { createSlice } from '@reduxjs/toolkit';
import {
  fetchNotificationSettings,
  saveNotificationSettings,
  getEmployeeClaims,
} from './peopleThunks';

import { LOADING_STATES } from '../../utils/constants/loadingStates';
const initialState = {
  selectedEmployee: null,
  saveStatus: LOADING_STATES.IDLE,
  roleStatus: LOADING_STATES.IDLE,
  userRoles: {},
};

const peopleSlice = createSlice({
  name: 'people',
  initialState,
  reducers: {
    setSelectedEmployee: (state, action) => {
      state.selectedEmployee = action.payload;
    },

    clearSelectedEmployee: (state) => {
      state.selectedEmployee = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // get notifications
      .addCase(fetchNotificationSettings.pending, (state) => {
        state.status = LOADING_STATES.LOADING;
      })
      .addCase(fetchNotificationSettings.fulfilled, (state, action) => {
        state.status = LOADING_STATES.SUCCEEDED;
        state.employeeNotifications = action.payload;
      })
      .addCase(fetchNotificationSettings.rejected, (state, action) => {
        state.status = LOADING_STATES.FAILED;
        state.error = action.payload;
      })
      // save notifications
      .addCase(saveNotificationSettings.pending, (state) => {
        state.saveStatus = LOADING_STATES.LOADING;
      })
      .addCase(saveNotificationSettings.fulfilled, (state, action) => {
        state.saveStatus = LOADING_STATES.SUCCEEDED;
        state.employeeNotifications = action.payload;
      })
      .addCase(saveNotificationSettings.rejected, (state, action) => {
        state.saveStatus = LOADING_STATES.FAILED;
        state.error = action.payload;
      })
      // get user roles
      .addCase(getEmployeeClaims.pending, (state) => {
        state.roleStatus = LOADING_STATES.LOADING;
      })
      .addCase(getEmployeeClaims.fulfilled, (state, action) => {
        state.roleStatus = LOADING_STATES.SUCCEEDED;
        state.userRoles = action.payload;
      })
      .addCase(getEmployeeClaims.rejected, (state, action) => {
        state.roleStatus = LOADING_STATES.FAILED;
        state.error = action.payload;
      });
  },
});

export const { setSelectedEmployee, clearSelectedEmployee } = peopleSlice.actions;

export const selectUserRoles = (state) => state.people.userRoles;
export const selectSaveStatus = (state) => state.people.saveStatus;
export const selectSelectedEmployee = (state) => state.people.selectedEmployee;
export const selectNotificationSettings = (state) => state.people.employeeNotifications;

export default peopleSlice.reducer;
